import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, ToastController, Events } from 'ionic-angular';


//import {CondominiumIntercomButtonComponent} from '../../components/condominium-intercom-button/condominium-intercom-button';
import { DeviceProvider } from '../../providers/device/device';

import { MessageCreateIntercomPage } from '../../pages/message-create-intercom/message-create-intercom';
import { Device, Condominium, DomainEvents, DeviceCache, HousingUnit } from '../../models/models';
import { CondominiumProvider } from '../../providers/condominium/condominium';
import { CallPage } from '../call/call';
//import { WebrtcProvider } from '../../providers/webrtc/webrtc';
import { HousingUnitIntercomPage } from '../housing-unit-intercom/housing-unit-intercom';
import { AuthProvider } from '../../providers/auth/auth';
import { LoginPage } from '../login/login';
import { InterappProvider } from '../../providers/interapp/interapp';
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit';
import { ConfigProvider } from '../../providers/config/config';
import { AndroidBridgeProvider } from '../../providers/android/android-bridge';

@IonicPage()
@Component({
	selector: 'page-condominium-intercom',
	templateUrl: 'condominium-intercom.html'
	/*
	,
	providers:[DeviceProvider]
	*/
})
export class CondominiumIntercomPage {
	public condominium: Condominium;
	/**
	Caricamento in corso, a fine caricamento aggiorna sempre le UI
	*/
	private _isLoading: boolean = true;
	/**
Gestore aggiornamenti dispositivo corrente
	*/
	private deviceUpdatedHandler: any = (_actualDevice, _time, _previousDevice) => {

		console.debug('[CondominiumIntercomPage.deviceUpdatedHandler()] Dispositivo aggiornato, ricarico i dati')
		this.refresh();
	}

	public get isLoading(): boolean {
		return this._isLoading;
	};
	public set isLoading(value: boolean) {
		this._isLoading = value;
		if (this.isChangeDetected)
			this.changeDetector.detectChanges()
	}

	private _size: number = null;

	/**
	Unità già ordinate
	*/
	private _housingUnits: HousingUnit[];
	public set housingUnits(units: HousingUnit[]) {
		this._housingUnits = HousingUnitProvider.sort(units);
		if (this.isChangeDetected)
			this.changeDetector.detectChanges();
	}
	public get housingUnits(): HousingUnit[] {
		return this._housingUnits;
	}

	public get size(): number {
		return this._size ? this._size : this.condominium.housing_units.length;
	}

	private isChangeDetected = false;

	constructor(
		private android_bridge:AndroidBridgeProvider,
		private auth: AuthProvider,
		private changeDetector: ChangeDetectorRef,
		private navCtrl: NavController,
		private condominiums: CondominiumProvider,
		private devices: DeviceProvider,
		private events: Events,
		private interapp: InterappProvider,
		private toastCtrl: ToastController
	) {
	}

	/*
	Quando sta per visualizzare aggiorna i dati
	*/
	ionViewWillEnter() {
		//NOTE L'aggiornamento automatico configurazione dispositivo è gestito a livello di device provider in base al tipo di dispositivo corrente, non serve metterlo qui

		console.debug('[CondominiumIntercomPage.ionViewWillEnter()]', this.navCtrl)

		/*
		Se si aggiorna il dispositivo aggiorna i dati del condominio a cascata
		*/
		this.events.subscribe(DomainEvents.DEVICE_ACTUAL_UPDATED, this.deviceUpdatedHandler);

		//se era autenticato esce
		this.auth.logout();

		//Se esiste un salvataggio locale usa quello subito senza schermata di caricamento
		this.refresh(DeviceCache.CACHED);

		//poi prova a caricare da remoto
		this.refresh(DeviceCache.REMOTE);
	}

	ionViewDidEnter() {
		//NOTE i cambiamenti sino visibili solo dopo che è visualizzato, altrimenti producono eccezione
		this.isChangeDetected = true;
	}

	ionViewWillLeave() {
		this.isChangeDetected = false;
		this.events.unsubscribe(DomainEvents.DEVICE_ACTUAL_UPDATED, this.deviceUpdatedHandler);
	}

	public call(housingUnit, isVideoSent = true) {
		try {
			if (!housingUnit.intercom_user_id) {
				console.error("L'unità abitativa non dispone di un destinatario citofono configurato", housingUnit);
				return;
			}
			this.navCtrl.push(CallPage, {
				otherId: ConfigProvider.generatePeerIdUser(housingUnit.intercom_user_id),
				housingUnit: housingUnit,
				isVideoSent: isVideoSent
			});
		} catch (e) {
			console.error(e);
		}
	}

	chooseInteraction(unit) {
		this.navCtrl.push(HousingUnitIntercomPage, {
			housingUnit: unit,
			isSingleHousingUnit: false
		})
		return;
	}

	/**
	Avvia la procedura di apertura portone previo login
	*/
	public open() {
		let self = this;
		console.info('[CondominiumIntercom.open()] Login per aprire il portone')
		this.navCtrl.push(LoginPage, {
			//isOneTime: true,
			isTypeForced: true,
			next: CondominiumIntercomPage,
			nextNavParams: {},
			nextPush: false,//ritorna al pannello bottoni come root
			nextGuard: (_auth: AuthProvider) => {
				//NOTE Auth ricevuto come parametro è inizializzato parzialmente, senza alcuni metodi, uso quello iniettato
				return self.auth.canCondominiumOpen(self.condominium);
			},
			nextCall: () => {
				//this.interapp.openDoorway();
				//2025 migrato ad android bridge
				this.android_bridge.send_impulse()
				let toast = self.toastCtrl.create({
					message: 'Apertura portone..',
					position: 'middle',
					cssClass: 'primary',
					duration: 3000
				});
				toast.present();
				self.navCtrl.pop();
			}
		})
	}

	private refresh(cacheMode = DeviceCache.FALLBACK) {
		let self = this;
		if (!self.condominium || !self.condominium.housing_units) {
			this.isLoading = true;
		}
		this.devices.getActual(['condominium', 'condominium.housingUnits'], cacheMode).then((device: Device) => {
			console.log("Dati del device attuale recuperati: ", device);

			if (!device) {
				if (cacheMode != DeviceCache.CACHED) {//risposta corretta ma non abbiamo una configurazione
					console.warn('Dispositivo non configurato sul server');
					let toast = self.toastCtrl.create({
						message: 'Questo dispositivo non è configurato correttamente',
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					});
					toast.present();
				}
				self.isLoading = false;
				return;
			}

			if (!device.condominium_id) {
				if (cacheMode != DeviceCache.CACHED) {
					console.warn('Dispositivo non associato ad un condominio');
					let toast = self.toastCtrl.create({
						message: 'Questo dispositivo non è associato a un condominio',
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					});
					toast.present();
				}
				self.isLoading = false;
				return;
			}

			//Recupero condominio
			self.condominiums.getById(device.condominium_id, ['housingUnits']).then(condominium => {
				self.condominium = condominium;
				self.housingUnits = condominium.housing_units;
				if (condominium.housing_units.length == 1) {
					console.info('[CondominiumIntercomPage.refresh()] Condominio monoutente: Impostazione automatica della pagina citofono singola unità abitativa')
					self.navCtrl.setRoot(HousingUnitIntercomPage, {
						housingUnit: condominium.housing_units[0],
						isSingleHousingUnit: true
					})
				}
				self.isLoading = false;
			}).catch(error => {
				console.error('Errore caricando i dati del condominio del dispositivo', error);
				let toast = self.toastCtrl.create({
					message: 'Errore caricando i dati del condominio del dispositivo',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				});
				toast.present();
				self.isLoading = false;
			});
		}).catch(error => {
			console.error('Errore recuperando la configurazione del dispositivo', error);
			if (!self.condominium) {
				self.isLoading = false;

				let toast = self.toastCtrl.create({
					message: 'Errore recuperando i dati del condominio',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				});
				toast.present();
			}
		});
	}

	/**
	Accessor da vista per impostare size esplicitamente, se null usa il conteggio delle unità immobiliari del condominio
	*/
	public setSize(size: number) {
		this._size = size;
	}


	public text(housingUnit) {
		this.navCtrl.push(MessageCreateIntercomPage, {
			housingUnit: housingUnit
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/condominium-intercom/condominium-intercom.ts